module.exports = __webpack_public_path__ + "0a01052ff36b9b2808fb26011dd79be2.pdf";